<input [ngClass]="{'disabled-checkbox':isDisabled}"
class="form-check-input checkbox"
type="checkbox"
value=""
role="checkbox"
[checked]="isChecked"
[disabled]="isDisabled"
[readonly]="isReadonly"
(click)="onChange($event?.target?.checked)"
/>